import { render } from "./InterventionalCardiology.vue?vue&type=template&id=10e151d6"
import script from "./InterventionalCardiology.vue?vue&type=script&lang=ts"
export * from "./InterventionalCardiology.vue?vue&type=script&lang=ts"
script.render = render

export default script